import React, { useEffect, useState } from "react";
import axiosAuth from "../../api/axiosAuth";
import { API } from "../../components/config";
import { useAuth } from "../../context/AuthContext";
import "../../style/Perfil.css";

export default function RectorPerfil() {
  const { token, user } = useAuth();

  const [rector, setRector] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

 useEffect(() => {
  if (!token) return;

  let isMounted = true;

  const fetchPerfil = async () => {
    try {
      setLoading(true);
      setError("");

      const res = await axiosAuth.get("/perfiles/me");

      if (isMounted) {
        setRector(res.data);
      }
    } catch (err) {
      console.error("❌ Error cargando perfil:", err);

      if (!isMounted) return;

      if (err.response?.status === 404) {
        setError("Usuario no encontrado.");
      } else if (err.response?.status === 401) {
        setError("Sesión expirada.");
      } else {
        setError("Error cargando perfil.");
      }
    } finally {
      if (isMounted) setLoading(false);
    }
  };

  fetchPerfil();

  return () => {
    isMounted = false;
  };
}, [token]);


  // 🔄 LOADING
  if (loading) {
    return (
      <div className="perfil-skeleton">
        <div className="skeleton-avatar"></div>
        <div className="skeleton-line"></div>
        <div className="skeleton-line short"></div>
      </div>
    );
  }

  // ❌ ERROR
  if (error) {
    return <p className="perfil-error">{error}</p>;
  }

  // ⚠️ NO DATA
  if (!rector) {
    return <p className="perfil-error">Perfil no encontrado</p>;
  }

  return (
    <div className="perfil-card">
      <div className="perfil-header">
        <div className="perfil-avatar-wrapper">
          <img
            src={
              rector.foto
                ? `${API}${rector.foto}`
                : "/default-profile.png"
            }
            alt="Perfil"
            className="perfil-avatar"
          />
        </div>

        <h2>
          {rector.nombre} {rector.apellido}
        </h2>

        <span className="perfil-rol">
          {rector.role || user?.role || user?.rol || "Rector"}
        </span>
      </div>

      <div className="perfil-body">
        <div className="perfil-item">
          <span>Email</span>
          <p>{rector.email || "No disponible"}</p>
        </div>

        <div className="perfil-item">
          <span>Rol institucional</span>
          <p>{rector.role || user?.role || user?.rol || "Rector"}</p>
        </div>
      </div>
    </div>
  );
}
